import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { packageData } from "@/mixins/index";
import util from '@/libs/util';
import axios from 'axios';
export default {
  mixins: [popUp, packageData],
  data: function data() {
    return {
      otherSdkTypeList: [],
      dialogFormVisible: false,
      reqLoading: false,
      modifyData: "",
      formData: {
        file_version: '',
        file: ""
      },
      formDataParams: null,
      isReWrite: false,
      formDataPrimitive: {},
      formDataMake: {},
      fileList: [],
      rules: {
        file_version: [{
          required: true,
          message: "请填写版本",
          trigger: "blur"
        }],
        file: [{
          required: true,
          message: "请上传文件",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {// this.getcommonData(['otherSdkTypeList'])
  },
  // watch: {
  //   'formData.file_version'(val){
  //     console.log("=======",this.modifyData)
  //     if(val != this.modifyData){
  //       this.rules.file[0].required = true;
  //     }else{
  //       this.rules.file[0].required = false;
  //     }
  //   },
  // },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.rules.file[0].required = true;
                _this.modifyData = "";

                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData = _objectSpread({}, datas); // this.modifyData = data.file_version;

                  _this.rules.file[0].required = false;
                }

                _this.fileList = [];
                _this.formData.file = "";
                _this.isReWrite = true;

                _this.copyData();

                _this.dialogFormVisible = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleExceed: function handleExceed() {
      this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u4E00\u4E2A\u6587\u4EF6!");
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      this.formData.file = fileList.length ? fileList[0].raw : "";
      console.log("this.formData.file==", this.formData.file);
    },
    // 格式化文件大小（带单位）
    formatFileSize: function formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      var i = Math.floor(Math.log(bytes) / Math.log(1024));
      return "".concat((bytes / Math.pow(1024, i)).toFixed(2), " ").concat(units[i]);
    },
    handleRemove: function handleRemove(file, fileList) {
      // 从fileList中移除当前文件
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
      this.formData.file = "";
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 20;

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }

      return isLt10M;
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = true;
      this.clearData(isClear);
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = false;
      this.fileList = [];
      this.formData.file = '';
      this.formData = JSON.parse(JSON.stringify(isClear ? this.formDataPrimitive : this.formDataMake));
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.formDataParams = new FormData();
      Object.keys(this.formData).forEach(function (key) {
        _this2.formDataParams.append(key, _this2.formData[key]);
      });
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this2.reqLoading = true;
                    data = JSON.parse(JSON.stringify(_this2.formData));
                    reqFn = data.id ? 'operation/oaidConfigManageUpdate' : 'operation/oaidConfigManageAdd'; //新增

                    axios.post(process.env.VUE_APP_API + reqFn, _this2.formDataParams, {
                      headers: {
                        'Content-Type': 'multipart/form-data',
                        "Authorization": 'Bearer ' + (util.cookies.get('token') || '')
                      }
                    }).then(function (res) {
                      if (res.data.status == 200) {
                        _this2.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      }
                    }).finally(function () {
                      _this2.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};